/* eslint-disable prettier/prettier */
import { Button } from '@service-victoria/component-library';
import Alert from '@service-victoria/component-library/components/Icons/Alert';
import device from '@service-victoria/component-library/utils/device';
import colors from '@service-victoria/component-library/utils/colors';
import styled from 'styled-components';
import chevronDownIconPath from 'app/assets/icons/chevron-down.svg';

export const NavWrapper = styled.div`
  background: ${colors.orange};
`;

export const Nav = styled.div`
  color: ${colors.white};
  font-family: VIC;
  font-size: 20px;
  font-weight: 700;
  margin: 0 auto;
  max-width: 1400px;
  padding: 5px 20px;
  box-sizing: border-box;
`;

export const HeaderWrapper = styled.div`
  background: ${colors.blueGrey};
`;

export const Header = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;

  @media ${device.isMobile} {
    margin-bottom: 30px;
  }
`;

export const Heading = styled.h1`
  color: #ffffff;
  font-family: VIC;
  font-size: 40px;
  font-weight: 700;
  margin: 0 0 20px 0;
`;

export const Description = styled.p`
  color: #ffffff;
  font-family: VIC;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 30px 0;
  max-width: 900px;

  @media ${device.isMobile} {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  padding: 40px 0 22px 0;
  background-color: ${colors.blueGrey10};

  @media ${device.isMobile} {
    padding-top: 60px;
    display: block;
  }
`;

export const Content = styled.div`
  max-width: 1400px;
  margin: 0 auto;

  display: flex;
  flex-wrap: wrap;
`;

export const ColumnWrapper = styled.div`
  box-sizing: border-box;
  padding: 0 20px;
  width: 50%;
  border-right: 1px solid ${colors.blueGrey25};

  :last-child {
    border-right: none;
  }

  @media ${device.isMobile} {
    width: 100%;
    padding: 10px 20px 20px 20px;
    border-right: none;
  }
`;

export const ClosureContentWrapper = styled.div`
  @media ${device.isTabletAndAbove} {
    display: flex;
  }
`;

export const AlertIcon = styled(Alert).attrs({ fill: colors.orange })`
  position: absolute;
  left: 1.2rem;
  height: 30px;
  width: 30px;
`;

export const Banner = styled.div`
  position: relative;
  background-color: white;
  border: 2px solid ${colors.orange};
  padding: 1rem;
  padding-left: 4rem;
  margin-top: 1rem;

  @media ${device.isTabletAndAbove} {
    margin-right: 2rem;
  }
`;

export const RedeemButton = styled(Button)`
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 0 auto;
  padding: 0 60px;
  min-width: 300px;
  align-self: end;

  @media ${device.isMobile} {
    position: absolute;
    margin-top: 50px;
    width: calc(100% - 40px);
  }
`;

export const SubHeading = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${colors.blueGrey};
  margin: 0;
`;

export const Section = styled.div`
  border-bottom: 1px solid ${colors.blueGrey25};
  padding: 10px 0;

  :last-child {
    border-bottom: none;
  }
`;

export const SectionHeading = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.blueGrey};
  margin: 10px 0;
`;

export const Label = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${colors.blueGrey};
  margin: 15px 0 5px 0;
`;

export const Value = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.blueGrey};
  margin: 0 0 10px 0;
`;

export const DashboardButton = styled.button`
  display: block;
  cursor: pointer;
  background: ${colors.white};
  border: none;
  padding: 30px 20px;
  margin: 20px 0;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  width: 100%;
  box-sizing: border-box;

  svg {
    width: 16px;
    height: 16px;
    margin: 5px 15px;
  }
`;

export const DashboardButtonTitleWrapper = styled.div`
  display: flex;
`;

export const DashboardButtonTitle = styled.h4`
    font-family: VIC;
    font-size: 18px;
    font-weight: 600;
    color: ${colors.blueGrey};
    margin: 0;
    padding: 0;
    text-align: left;
}
`;

export const DashboardButtonDescription = styled.p`
    text-align:left;
    font-family: VIC;
    font-size: 16px;
    font-weight: 400;
    margin: 15px 0 0 15px;
    color: ${colors.blueGrey};
}
`;

export const Footer = styled.div`
  background-color: ${colors.blueGrey10};
  display: flex;
  justify-content: start;
  padding: 20px 40px 40px 40px;
  max-width: 1400px;
  margin: 0 auto;

  img,
  div {
    height: 50px;
    margin: 0 10px;
  }

  @media ${device.isMobile} {
    justify-content: center;
    padding-top: 0;
  }
`;

export const DropdownWrapper = styled.div`
  float: right;
  select {
    text-align: right;
    border: none;
    color: ${colors.white};
    font-family: VIC;
    font-size: 20px;
    font-weight: 700;
    padding-right: 24px;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: ${colors.orange};
    background: url("${chevronDownIconPath}") no-repeat 100%;
    background-size: 12px;
    display: inline-block;
    &:focus,
    &:hover {
      outline: none;
      border: none;
    }
  }
  select option {
    color: black;
  }
  @media ${device.isMobile} {
    select {
      display: flex;
      justify-content: end;
      width: 0em;
      border: unset;
    }
  }
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2;
`;

export const ProviderNameWrapper = styled.span`
  display: inline;
  float: right;
  @media ${device.isMobile} {
    display: none;
  }
`;
